<template>
  <v-container
    fluid
    class="secondary fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col cols="6">
        <!-- login card -->
        <v-card
          rounded="lg"
          class="pa-5"
        >
          <!-- login form -->
          <v-form @submit.prevent="login">
            <v-card-title class="primary--text">Login</v-card-title>
            <v-card-text>
              <!-- username -->
              <v-text-field
                v-model="username"
                autofocus
                label="Username"
                :disabled="loading"
              ></v-text-field>
              <!-- password -->
              <v-text-field
                v-model="password"
                label="Password"
                :disabled="loading"
                type="password"
              ></v-text-field>

              <!-- error handler -->
              <span :class="`${ success ? 'success' : 'error'}--text`">
                {{ success || error }}
              </span>

              <div>
                <!-- forgot password -->
                <v-hover v-slot="{ hover }">
                  <router-link to="/password/reset" :class="{'no-underline':!hover}">
                    Forgot password?
                  </router-link>
                </v-hover>
              </div>
            </v-card-text>
            <!-- login button -->
            <v-card-actions>
              <v-btn
                large
                rounded
                color="primary"
                width="100%"
                type="submit"
                class="mx-auto"
                :disabled="loading"
              >
                Login
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
        <!-- loading prompt -->
        <v-progress-linear
          color="primary"
          indeterminate
          :active="loading"
        ></v-progress-linear>
      </v-col> 
    </v-row>
  </v-container>
</template>

<script>
  import testData from '@/assets/testdata.js'
  
  // will be used when ready
  import API from '@/api'
  const User = API.get('User');

  export default {
    Name: 'Login',

    data: ()=>({
      username: '',
      password: '',
      // username: 'jfragante@medgate.ph',
      // password: 'Medgate123!',
      error: '',
      success: '',
      loading: false,
    }),

    methods: {
      async login () {
        var userInvalid = !this.validateInput(this.username) 
        var passInvalid = !this.validateInput(this.password) 
        if ( userInvalid || passInvalid) {
          return;
        }

        this.resetMessages();
        this.loading = true;
        
        try {
          // testdata
          var testResponse = await testData.login(this.username, this.password);

          if (!testResponse) {
            var response = await User.login(this.username, this.password);

            if (!response) {
              this.error = "Username doesn't exist";
            }
            else {
              this.$store.dispatch('profile/signIn', {
                user : response.data.user,
                token : response.data.token.accessToken
              });
              
              this.success = 'Logged in successfully!'
            }
          }
          else {
            this.$store.dispatch('profile/signIn', {
              user : testResponse.user,
              token : testResponse.token.accessToken
            });
            
            this.success = 'Logged in successfully!'
          }

          localStorage.removeItem('login_session_key');

          // REAL LOGIN
          // var response = await User.login(this.username, this.password);

          // if (!response) {
          //   this.error = "Username doesn't exist";
          // }
          // else {
          //   this.$store.dispatch('profile/signIn', {
          //     user : response.data.user,
          //     token : response.data.token.accessToken
          //   });
            
          //   this.success = 'Logged in successfully!'
          // }

          // *
          // var response = await User.login(this.username, this.password);
          // if ( response.data.user.user_type !== 'doctor' ) {
          //   this.error = 'Unauthorized access';
          // } 
          // else {
          //   this.success = 'Logged in successfully!'
          //   localStorage.setItem('auth_token', response.data.token.accessToken);
          //   this.$store.commit('doctor/setProfile', response.data.user.doctor);
          //   this.$router.push({name: 'Main'});
          // }
        }
        catch(error) {
          this.error = error.response.data;
        }

        this.loading = false;
      },
      /**
       * Reset Password
       */


      /** HELPERS */

      resetMessages() {
        this.error = '';
        this.success = '';    
      },
      saveUser (auth_token, userData) {
        localStorage.setItem('auth_token', auth_token);
        this.$store.commit('profile/setProfile', userData);
      },
      // not done yet
      validateInput (input) {
        if (input) return true
        else return true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .no-underline {
    text-decoration: none;
  }
</style>